export default __webpack_public_path__ + "static/media/1-Cloudxier-DailyCaffeine.573bfa2e.jpg";